import React, { Component } from 'react'
import Axios from '../../../config/axios'
import withErrorHandler from 'hoc/withErrorHandler'
import { DatePicker, PageHeader, Button, Empty } from 'antd';
import '../../../style.css'
import Loading from 'components/Loading';
import { Link } from 'react-router-dom';

const { RangePicker } = DatePicker;

class Report extends Component {

    state = {
        report : [],
        showReport:false,
        startDate: '',
        endDate: ''
    }
    handleChangeDate = (date, dateString) => {                
        this.setState({ startDate: dateString[0], endDate: dateString[1] })
    }

    handleShow = () => {
        let params = {}
        if(this.state.startDate) params.start_date = this.state.startDate
        if(this.state.endDate) params.end_date = this.state.endDate
        Axios.get("/report"+ (this.props.user.info.type !== 'admin' ? '?unit_id='+this.props.user.info.unit_id : ''),
        {
            params: params
        }).then(response => {
            this.setState({ report: response.data, showReport: true })
        })
    }

        
    render(){    
        return(           
            <div className="site-layout-background" style={{ padding: 10, minHeight: 360 }}>
                <PageHeader
                    className="site-page-header"
                    onBack={() => null}
                    backIcon={null}
                    title="Laporan"
                    subTitle="Laporan permohonan surat"                
                    extra={[
                        <RangePicker 
                            key={1}                             
                            onChange={this.handleChangeDate}
                        />,
                        <Button key={2} onClick={this.handleShow} >Muat Laporan</Button>,
                        <Link key={3} to={{pathname: "/laporan/cetak",  state:this.state.report}} >
                            <Button  type="primary">Cetak Laporan</Button>
                        </Link>
                    ]}
                />
                {
                    this.state.showReport ? 
                    this.state.report.map((repo, index) => 
                    <div className="ant-table-content" style={{marginTop:50}} key={index}>
                    <h4>Program Studi: {repo.name}</h4>                    
                    <table style={{tableLayout: 'auto', width:'100%'}}>
                        <thead className="ant-table-thead">
                            <tr>
                                <th rowSpan="2" className="ant-table-cell">No</th>                                
                                <th rowSpan="2" className="ant-table-cell">Nama Surat</th>                                
                                <th colSpan="4" className="ant-table-cell">Aksi</th>
                            </tr>
                            <tr>
                                <th>Masuk</th>
                                <th>Sedang Diproses</th>
                                <th>Selesai</th>
                                <th>Ditolak</th>
                            </tr>
                        </thead>
                        <tbody className="ant-table-tbody">
                            {
                                repo.total.map((repo, index) => 
                                    <tr key={index} className="ant-table-row ant-table-row-level-0">
                                        <td className="ant-table-cell">{index+1}</td>                                        
                                        <td className="ant-table-cell">{repo.letter_name}</td>                                        
                                        <td className="ant-table-cell">{repo.total.submitted}</td>
                                        <td className="ant-table-cell">{repo.total.processed}</td>
                                        <td className="ant-table-cell">{repo.total.finished}</td>
                                        <td className="ant-table-cell">{repo.total.rejected}</td>
                                    </tr>)
                            }
                        </tbody>
                    </table>
                    </div>
                    )
                    
                    :
                    <div style={{marginTop:100}}>
                    <Empty />
                    </div>
                }
               
               <Loading loading={this.props.loading} />
            </div>
        )
    }
}

export default withErrorHandler(Report, Axios)